import { ConfigService } from '../../../../libs/shared/core/src';

export const ServiceInjectorMapper = {
	configs: ConfigService,
};
